import Styles from './TwitterPost.module.scss'
import { Skin } from '../Skin'
import { SkinProps } from '../Types'

const TwitterPost = ({ children, maxCharacterCount }: SkinProps) => {
  return (
    <Skin.Root className={Styles.twitterPost} data-testid="twitter-frame-skin">
      <Skin.CaptionAbove lines={5} maxCharacterCount={maxCharacterCount} />
      {children}
    </Skin.Root>
  )
}

export { TwitterPost }
